var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.show_notif
      ? _c(
          "div",
          {
            staticClass:
              "alert border-danger bg-transparent text-secondary fade show billing-alert",
            attrs: { role: "alert" },
          },
          [
            _c("div", { staticClass: "d-flex align-items-start" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "flex-1" }, [
                _c(
                  "span",
                  { staticClass: "h5 color-danger-900 d-block mb-1" },
                  [
                    _vm._v(
                      "Увага, Вам потрбіно заповнити Декларування конфікту інтересів за рік"
                    ),
                    _c("div", [
                      _c("a", { attrs: { href: _vm.info.url_to } }, [
                        _vm._v("Перейти"),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert-icon mr-3" }, [
      _c("span", { staticClass: "icon-stack icon-stack-md" }, [
        _c("i", { staticClass: "base-7 icon-stack-3x color-danger-900" }),
        _vm._v(" "),
        _c("i", { staticClass: "fal fa-times icon-stack-1x text-white" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }